define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action/ActionView",
	"csi/breadcrumb/NewFromController",
	"csi/def",
	"csi/locale",
	"csi/xml"
], function(array,declare,ActionView,NewFrom,def,locale,xml) {

	return declare(NewFrom, {
		bNavigate: false,
		bUseNodeForForm: false,

		preProcess: function() {
			// summary: if no colors, then go straight to Theme form
			var	product = this.getParent();
			if (product.ProductColors.length) {
				this.inherited(arguments);
			} else {
				this._sourcesToCheck = [];
				this._popupSourceForm(product);
			}
		},

		getFormData: function() {
			// summary: for now use to select multiple colors, but in end will represent single selected product
			var	fd = this.inherited(arguments);
			fd.m_bSelectOne = false;
			return fd;
		},

		/**
		 * @override
		 * customize the successful message
		 */
		getSuccess: function() {
			const theme = locale.resource("Theme");
			return locale.resource("New_Success", [theme]);
		},

		/**
		 * Add the Save & Go button no matter how many items selected, since eventually one node is created
		 * @param {View} defView
		 * @param {Actions} defActions
		 */
		addProxyActions: function(defView, defActions) {

			if (defView && defView.getId() == def.DEFAULT_FORM_ID) {
				defActions.addAction(this.getProxyAction("Save_Go", true));
				defActions.addAction(this.getProxyAction("Save", true, {m_bSubmit: true}));
			}

			this.inherited(arguments);
		},

		storeSources: function() {
			// summary: store product as source and colors separately to pass to request
			this.inherited(arguments);

			if (this.m_aSources) {
				this._colors = array.map(this.m_aSources, xml.nodeGetURL);
			}

			this.m_aSources = [this.getParent()];
		},

		toWriterRequest: function() {
			// summary: add colors parameter
			var	call = this.inherited(arguments);

			if (this._colors) {
				call.addParameter("ColorURLs", xml.ATTR_REFLIST, this._colors);
			}

			return call;
		}
	});
});